import React, { useEffect } from 'react';
import { persistor, store } from '../../redux/store.jsx';
import { PersistGate } from 'redux-persist/integration/react';
import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import skSK from 'antd/lib/locale/sk_SK';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import dayjs from 'dayjs';
import AttendanceRoutes from './AttendanceRoutes.jsx';
import CoreCMSRoutes from './CoreCMSRoutes.jsx';
import ErasmusRoutes from './ErasmusRoutes.jsx';
import FacultyRoutes from './FacultyRoutes.jsx';
import FriEduRoutes from './FriEduRoutes.jsx';
import FriInternalJobsRoutes from './FriInternalJobsRoutes.jsx';
import FriJobsRoutes from './FriJobsRoutes.jsx';
import FriOpenRoutes from './FriOpenRoutes.jsx';
import MeteoRoutes from './MeteoRoutes.jsx';
import PollsRoutes from './PollsRoutes.jsx';
import PortalAdministrationRoutes from './PortalAdministrationRoutes.jsx';
import PublicRoutes from './PublicRoutes.jsx';
import RoomsReservationsRoutes from './RoomsReservationsRoutes.jsx';
import StudyProgramsRoutes from './StudyProgramsRoutes.jsx';
import YellowBooksRoutes from './YellowBooksRoutes.jsx';
import { routes } from '../../utils/helpers/ApiClient.jsx';
import AuthGate from '../AuthGate.jsx';
import PublicWrapper from '../PublicWrapper.jsx';
import MiddleLayout from '../layout/PublicLayout/MiddleLayout.jsx';
import { HttpError } from '../common/HttpError/index.jsx';
import NavigationEventListener from '../../utils/helpers/NavigationEventListener.jsx';
import AppVersionWatcher from '../../utils/helpers/AppVersionWatcher.jsx';
import useInitialAuth from '../../hooks/useInitialAuth.jsx';
import FriViaRoutes from './FriViaRoutes.jsx';
import PhdRoutes from './PhdRoutes.jsx';
import IngProjectsRoutes from './IngProjectsRoutes.jsx';
import WikiRoutes from './WikiRoutes.jsx';

const AppRoutes = () => {
  const isInitializing = useInitialAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n]);

  if (isInitializing) {
    return <></>;
  }

  return (
    <BrowserRouter>
      <NavigationEventListener />
      <AppVersionWatcher />
      <Routes>
        <Route
          path={routes.cmsDashboard}
          element={
            <AuthGate>
              <Outlet />
            </AuthGate>
          }
        >
          {AttendanceRoutes()}
          {CoreCMSRoutes()}
          {ErasmusRoutes()}
          {FacultyRoutes()}
          {FriEduRoutes()}
          {FriInternalJobsRoutes()}
          {FriJobsRoutes()}
          {FriOpenRoutes()}
          {IngProjectsRoutes()}
          {MeteoRoutes()}
          {PollsRoutes()}
          {PortalAdministrationRoutes()}
          {RoomsReservationsRoutes()}
          {StudyProgramsRoutes()}
          {YellowBooksRoutes()}
          {FriViaRoutes()}
          {PhdRoutes()}
          {WikiRoutes()}
        </Route>
        <Route
          path="/"
          element={
            <PublicWrapper>
              <Outlet />
            </PublicWrapper>
          }
        >
          {PublicRoutes()}
        </Route>
        <Route
          path="*"
          element={
            <PublicWrapper>
              <MiddleLayout hideRightSidebar>
                <HttpError statusCode={404} />
              </MiddleLayout>
            </PublicWrapper>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
